import React, { useState } from 'react';

import { showToast } from '@opendoor/bricks/complex/Toast';
import { Button, Flex, Text, TextArea } from '@opendoor/bricks/core';
import { Value } from 'classnames';

import { OdProtosListingsData_NoteType as NOTE_TYPE } from '../../__generated__/athenaGlobalTypes';
import { useSetNote } from '../../graphql/athena/mutations/SetNote';

type SetNoteFormProps = {
  lwcProductId: string;
  noteType: NOTE_TYPE;
  currentNote?: string;
};

/** Uses the note form to update the notes for a particular type of use case. */
export const SetNotesForm: React.FC<SetNoteFormProps> = ({
  lwcProductId,
  noteType,
  currentNote,
}) => {
  const [formData, setFormData] = useState(currentNote);
  const { setNote, error } = useSetNote();

  const handleSetNote = async (noteContent: string) => {
    setNote(lwcProductId, noteContent, noteType)
      .then(() => {
        showToast('info', `Successfully set ${NOTE_TYPES[noteType]}`, 'lwc-dashboard-toast}', {
          toastOptions: { autoClose: 3000 },
        });
      })
      .catch((_) => {
        // Just catch for now, log later
      });
  };

  const handleTextChange = (
    _event: React.ChangeEvent<HTMLTextAreaElement>,
    _name: string,
    value?: Value,
  ) => {
    setFormData((value as string) ?? null);
  };

  if (error) {
    showToast('error', `Error setting notes of type ${noteType}`, 'lwc-dashboard-toast', {
      toastOptions: { autoClose: false },
    });
  }
  return (
    <Flex flexDirection="column">
      <Text>Set {NOTE_TYPES[noteType]}</Text>
      <TextArea
        aria-label="Set note"
        content={formData}
        onChange={handleTextChange}
        name={noteType}
        analyticsName={`noteType-${noteType}`}
        id={noteType}
      />

      <Button
        aria-label={`Submit ${NOTE_TYPES[noteType]}`}
        analyticsName={`set-note-${noteType}`}
        onClick={() => (formData ? handleSetNote(formData) : null)}
        disabled={formData === currentNote}
      >
        Submit note
      </Button>
    </Flex>
  );
};

export const NOTE_TYPES = {
  [NOTE_TYPE.AGENT_NOTE]: 'Agent note',
  [NOTE_TYPE.CEP_NOTE]: 'CEP note',
  [NOTE_TYPE.LEAD_PASS_BACK_NOTE]: 'Lead pass back note',
  [NOTE_TYPE.UNKNOWN_NOTE]: 'Unknown note',
};
